// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat_wrap {\n  width: 100%;\n  background-color: #f6f8fb; }\n  @media (max-width: 768px) {\n    .chat_wrap {\n      padding-top: 0px; } }\n  .chat_wrap .section {\n    position: relative;\n    min-height: calc(100vh - 99px);\n    background-color: #ffffff;\n    border-right: solid 1px #dee3eb;\n    border-left: solid 1px #dee3eb;\n    width: 786px;\n    margin: 0 auto;\n    padding-top: 0px; }\n    @media (min-width: 1281px) {\n      .chat_wrap .section {\n        width: 970px !important; } }\n    @media (max-width: 1024px) {\n      .chat_wrap .section {\n        width: 93%;\n        margin: 0 auto; } }\n    @media (max-width: 768px) {\n      .chat_wrap .section {\n        width: 100%;\n        margin: 0 auto;\n        border: none;\n        padding: 0px !important;\n        min-height: calc(100vh - 54px); } }\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/lib/loader.js!./Src/Containers/Chat/ChatPage.scss
// module id = 4495
// module chunks = 1